import MatchedMap from 'utilities/src/matchedMap';

import type { InputThemeProps } from '../../../shared/utils/themes';

import { ThemeEnum, useTheme } from '../../../../Theme';

/**
 * Import Themes
 */

import inputTextareaCommonTheme from './common';

import inputTextareaBlogTheme from './_blog';
import inputTextareaSiteTheme from './_site';

/**
 * Group Themes
 */

const inputTextareaThemes = new MatchedMap([
  [ThemeEnum.Blog, inputTextareaBlogTheme],
  [ThemeEnum.Site, inputTextareaSiteTheme],
]);

/**
 * Theme Hook
 */

const useInputTextareaTheme = (fieldThemeProps: Pick<InputThemeProps, 'inputState'>) =>
  useTheme(inputTextareaCommonTheme(fieldThemeProps), inputTextareaThemes);

export default useInputTextareaTheme;
